import React from 'react';
import { Head, Link, router } from '@inertiajs/react';
import DashboardLayout from '../../../components/DashboardLayout';
import { Button } from '../../../components/ui/button';
import { Card } from '../../../components/ui/card';

interface GeonameImport {
  id: number;
  status: string;
  created_at: string;
  statistics?: any;
}

interface IndexProps {
  imports: GeonameImport[];
}

const Index: React.FC<IndexProps> = ({ imports }) => {
  return (
    <DashboardLayout>
      <Head title="Geoname Imports" />

      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-foreground">Geoname Imports</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Manage geoname data imports.
            </p>
          </div>
          <Link href="/admin/geonames/new">
            <Button>New Import</Button>
          </Link>
        </div>

        <Card className="rounded-xl border bg-card text-card-foreground shadow">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-border">
            <thead className="bg-muted">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Created At
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Statistics
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-card divide-y divide-border">
              {imports.map((importItem) => (
                <tr key={importItem.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-foreground">
                    {importItem.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground">
                    {importItem.status}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground">
                    {importItem.created_at}
                  </td>
                  <td className="px-6 py-4 text-sm text-muted-foreground">
                    <pre className="whitespace-pre-wrap">
                      {importItem.statistics ? JSON.stringify(importItem.statistics, null, 2) : 'N/A'}
                    </pre>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button
                      onClick={() => {
                        if (window.confirm('Are you sure you want to delete this geoname import? This action cannot be undone.')) {
                          router.delete(`/admin/geonames/${importItem.id}`);
                        }
                      }}
                      className="text-destructive hover:text-destructive/80"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            </table>
          </div>
        </Card>

        {imports.length === 0 && (
          <div className="text-center py-12">
            <p className="text-muted-foreground">No imports found.</p>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Index;